export const COUNTRY_CODES = {
  spain: 'ES',
  italy: 'IT',
  portugal: 'PT',
  germany: 'DE',
  uae: 'AE',
  netherlands: 'NL',
  austria: 'AT',
  uk: 'GB',
  france: 'FR',
  belgium: 'BE',
  hungary: 'HU',
  czech: 'CZ',
  colombia: 'CO',
  thailand: 'TH',
  romania: 'RO',
  greece: 'GR',
  slovenia: 'SI',
  croatia: 'HR',
  usa: 'US',
  canada: 'CA',
  sweden: 'SE',
  switzerland: 'CH',
  poland: 'PL',
  bulgaria: 'BG',
  japan: 'JP',
  ukraine: 'UA',
  brazil: 'BR',
  china: 'CN',
  ireland: 'IE',
  argentina: 'AR',
  mexico: 'MX',
  australia: 'AU',
  morocco: 'MA',
  turkey: 'TR',
  denmark: 'DK',
  russia: 'RU',
  india: 'IN',
  israel: 'IL',
  southKorea: 'KR',
  norway: 'NO',
  slovakia: 'SK',
  venezuela: 'VE',
  lithuania: 'LT',
  saudiArabia: 'SA',
  peru: 'PE',
};
